import { Component, OnInit, NgZone, EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SidebarService } from '../../services/sidebar.service';
import { GlobalService } from '../../services/global.service';

import { ModalService } from '../modal/modal.service';
import Utils from 'app/shared/utility';

import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-sidebar-client',
  templateUrl: './sidebar-client.component.html',
  styleUrls: ['./sidebar-client.component.css']
})
export class SidebarClientComponent implements OnInit {
  
  @Output() hideFABIcon: EventEmitter<boolean> = new EventEmitter();

  public screenVisible: Boolean;
  public selectedClient: any;
  public selectedClientSpouse: any;
  public error: string;

  public hideAllCoverageOptions: boolean = false;
  public hideAllOOP: boolean = false;
  public hideAllCoverageOptionsSpouse: boolean = false;
  public hideAllOOPSpouse: boolean = false;
  public hideAdditionalQuestions: boolean = false;

  public userType: number;
  public visible: boolean;
  public isTopGA: boolean;

  isClientVisible: boolean;
  showMobile: boolean = false;

  get hasSupportTickets(): boolean {
    return this.globalService.hasCreatedSupportTickets();
  }
  showMenu: boolean = false;
  isAdditinalQuestionVisible: boolean;
  isIncomeVisible: boolean;
  isSpouseAdditinalQuestionVisible: boolean;
  isSpouseIncomeVisible: boolean;
  featAdditionalQuestions: boolean;
  isPre65: boolean;
  isSpousePre65: boolean;

  myInnerHeight: string;
  slideOutTrayVisible: boolean = false;

  tabIndex : number = 0;
  agiText: string = 'Modified AGI:'



  constructor(public sidebarService: SidebarService, private router: Router, private ngZone: NgZone, private globalService: GlobalService,private modalService: ModalService) {
    // This sidebar status should only occur when on a report page (viewing, editing, creating)
    //console.log(window.screen.height);
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe(event => this.handleSidebarStatus((event as NavigationEnd).url));

    // router.events.subscribe((evt) => {
    //   if (evt.constructor.name === 'NavigationEnd') {
      modalService.modal$.subscribe((modal) => {
        
      });
        
    //   }
    // });

    sidebarService.clientUpdated.subscribe(()=>{
      console.log('zss triggered refresh of sidenav data');
      this.handleSidebarStatus(this.router.url);
    });

    window.onresize = () => { // Detect screen size and resizing
      ngZone.run(() => {
        if (window.innerWidth < 900 && this.screenVisible) {
          this.screenVisible = false;
        } else if (window.innerWidth >= 900 && !this.screenVisible) {
          this.screenVisible = true;
        }
      })
    }
    if (this.router.url == '/clients/edit/healthcare/options/hcq' || this.router.url == '/clients/edit/long-term-care/options/ltcq' || this.router.url == '/clients/edit/combined/options/hcltc') {
      this.slideOutTrayVisible = true;
    } 
  }

  ngOnInit() {
    this.screenVisible = window.innerWidth < 900 ? false : true;
    this.featAdditionalQuestions = localStorage.getItem('featAdditionalQuestions') == 'true' ? true: false;
    this.userType = Number(localStorage.getItem('roleId')) || 3;

    //this.visible = //(Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isTopGA = (Number(localStorage.getItem('roleId')) === 2 || Number(localStorage.getItem('roleId')) === 1) && Number(localStorage.getItem('parentID')) === 0 ? true : false;
  }

  handleSidebarStatus(url) {
    this.userType = Number(localStorage.getItem('roleId')) || 3;
    const clientActive = localStorage.getItem("selectedClient") != null
      && (url == '/reports/new' || url === '/clients/edit' || (url.includes('/clients/edit') 
      && (url.includes('/options/') || url.includes('/social-security') || url.includes('/healthcare') 
      || url.includes('/long-term-care') || url.includes('/combined'))));

    if (clientActive) {
      this.getClientData();
      this.visible = true;
      this.isClientVisible = true;
    } else {
      this.isClientVisible = false;
      // Hide Support side navigation / panel for now
      this.visible = false; // (this.userType === 1 || this.hasSupportTickets);
    }

    if(url.includes('/options/')){
      
    } else {
      this.sidebarService.open();
      this.slideOutTrayVisible = true;
    }
  }

  toggleSlideOutTray() {
    this.slideOutTrayVisible = !this.slideOutTrayVisible;
    // if someone update the alt age from ss alt modal without reloading the illustration (router) then this will fix it
    console.log('this.globalService.isAltComplete', this.globalService.isAltComplete)
    if (this.slideOutTrayVisible && this.globalService.isAltComplete) {
      console.log('change isAltComplete')
      this.globalService.isAltComplete = false;
      this.getClientData();
      
    }
  }


  getClientData() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
    .subscribe(
        client => { 
          console.log('sidenav client', client);
          if (!localStorage.getItem('selectedAdvisorID') || localStorage.getItem('selectedAdvisorID') == 'undefined') {
            localStorage.setItem('selectedAdvisorID', client.advisor.ID);
          }
          if (!localStorage.getItem('selectedAdvisorOrgID') || localStorage.getItem('selectedAdvisorOrgID') == 'undefined') {
            localStorage.setItem('selectedAdvisorOrgID', client.advisor.OrganizationID);
          }
          // 
          // localStorage.setItem('selectedAdvisorOrgID', client.advisor.OrganizationID);
          this.selectedClient = client;
          this.selectedClient.clientProfile.CoverageType = this.selectedClient.clientProfile.IsPrivHealthIns ? this.selectedClient.clientProfile.CoverageType : '--';

          // selectedClientSpouse.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
          var selectedClientSpouse = JSON.parse(client.clientProfile.Spouses);
          this.selectedClientSpouse = selectedClientSpouse[0];

          let isHCFilledBefore = this.selectedClient.clientProfile.PremiumType ? true: false;
          let isSSFilled = this.selectedClient.clientProfile.MonthlyBenefitAmount || this.selectedClient.clientProfile.PIA || this.selectedClient.clientProfile.SelfKnownBenefitClaiming ? true : false;
          this.agiText = isHCFilledBefore && !isSSFilled ? 'Household MAGI:' : this.agiText;
          
          if(this.selectedClient.clientProfile.ClientMetroArea){
            this.getLTCStateRegions(this.selectedClient.clientProfile.RetirementState, true);
          }

          if(this.selectedClientSpouse.maritalStatus === 'Married' && this.selectedClient.clientProfile.SpouseMetroArea){
            this.getLTCStateRegions(this.selectedClientSpouse.state, false);
          }

          this.getMMTBracket();
          //reset premiums/OOPs as an object
          //this.selectedClient.clientProfile.Premiums = JSON.parse(JSON.parse(client.clientProfile.Premiums));
          //this.selectedClient.clientProfile.OOPCosts = JSON.parse(JSON.parse(client.clientProfile.OOPCosts));
          if(this.selectedClient.clientProfile.Premiums && this.selectedClient.clientProfile.Premiums != 'null'){
            this.selectedClient.clientProfile.Premiums = JSON.parse(client.clientProfile.Premiums);
            this.selectedClient.clientProfile.OOPCosts = JSON.parse(client.clientProfile.OOPCosts);

            this.selectedClient.clientProfile.SpousePremiums = JSON.parse(client.clientProfile.SpousePremiums);
            this.selectedClient.clientProfile.SpouseOOPCosts = JSON.parse(client.clientProfile.SpouseOOPCosts);
            //this.selectedClient.clientProfile.SpousePremiums = JSON.parse(JSON.parse(client.clientProfile.SpousePremiums));
            //this.selectedClient.clientProfile.SpouseOOPCosts = JSON.parse(JSON.parse(client.clientProfile.SpouseOOPCosts));

            //check if need to hide whole sections in slideout
            this.hideAllCoverageOptions = ((this.selectedClient.clientProfile.PremiumType == "TM") 
              ? !(!this.selectedClient.clientProfile.Premiums.MedicarePartB 
                && !this.selectedClient.clientProfile.Premiums.MedicarePartD 
                && !this.selectedClient.clientProfile.Premiums.SupplimentalInsurance 
                && !this.selectedClient.clientProfile.Premiums.DentalInsurance) 
              : (this.selectedClient.clientProfile.PremiumType == "PPO") ? 
                !(!this.selectedClient.clientProfile.Premiums.MedicareAdvantagePPO) 
              : !(!this.selectedClient.clientProfile.Premiums.MedicareAdvantageHMO));

            this.isPre65 = (Number(client.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(client.client.DOB)) >= 65) ? false : true;
            //this.hideAllCoverageOptions = !isPre65 ? false : this.hideAllCoverageOptions;

            this.hideAllOOP = !(!this.selectedClient.clientProfile.OOPCosts.HospitalAndTest 
              && !this.selectedClient.clientProfile.OOPCosts.HearingAndVisionCosts 
              && !this.selectedClient.clientProfile.OOPCosts.DentalCosts 
              && !this.selectedClient.clientProfile.OOPCosts.PrescriptionDrugs);

            //Do we really need 'Spouse' on everything ?
            if(this.selectedClient.clientProfile.SpousePremiums){
              this.hideAllCoverageOptionsSpouse = !(!this.selectedClient.clientProfile.SpousePremiums.SpouseMedicarePartB 
                && !this.selectedClient.clientProfile.SpousePremiums.SpouseMedicarePartD 
                && !this.selectedClient.clientProfile.SpousePremiums.SpouseSupplimentalInsurance 
                && !this.selectedClient.clientProfile.SpousePremiums.SpouseDentalInsurance 
                && !this.selectedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO 
                && !this.selectedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO);
              var spouse = JSON.parse(this.selectedClient.clientProfile.Spouses);
              this.isSpousePre65 = ((Number(spouse[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(spouse[0].dob)) >= 65) ? false: true);
              //this.hideAllCoverageOptionsSpouse = !isSpousePre65 ? false : this.hideAllCoverageOptionsSpouse;
            }

            if(this.selectedClient.clientProfile.SpouseOOPCosts){
              this.hideAllOOPSpouse = !(!this.selectedClient.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest 
                && !this.selectedClient.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts 
                && !this.selectedClient.clientProfile.SpouseOOPCosts.SpouseDentalCosts 
                && !this.selectedClient.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs);
            }

            this.hideAdditionalQuestions = (this.hideAllCoverageOptions || this.hideAllOOP || this.hideAllOOPSpouse || this.hideAllCoverageOptionsSpouse);
          }
          //ZSS 04/11/23: below removed because client can have $0 on PIA and monthly benefit
          //this.isAdditinalQuestionVisible = this.selectedClient.clientProfile.PIA ? true: false;
          this.isAdditinalQuestionVisible = (this.selectedClient.clientProfile.IRR || this.selectedClient.clientProfile.CurrentIncome || this.selectedClient.clientProfile.HouseholdYearOneIncome ||  this.selectedClient.clientProfile.Bracket || (this.selectedClient.clientProfile.RetirementState && this.selectedClient.clientProfile.ClientMetroArea)) && this.globalService.featAdditionalQuestions ? true : false;
          this.isIncomeVisible = this.selectedClient.clientProfile.IRR || this.selectedClient.clientProfile.CurrentIncome || this.selectedClient.clientProfile.HouseholdYearOneIncome ||  this.selectedClient.clientProfile.Bracket 
            || ((this.selectedClient.clientProfile.RetirementState && this.selectedClient.clientProfile.ClientMetroArea) || (this.selectedClient.clientProfile.RetirementState == 'NA')) ? true : false;
          this.visible = this.isIncomeVisible;

          console.log('this.isIncomeVisible', this.isIncomeVisible);
          if (this.selectedClientSpouse) {
            this.isSpouseAdditinalQuestionVisible = this.isAdditinalQuestionVisible;// this.selectedClientSpouse.pia ? true: false;
            this.isSpouseIncomeVisible = this.selectedClientSpouse.currentIncome ||  this.selectedClient.clientProfile.HouseholdYearOneIncome || this.selectedClient.clientProfile.Bracket? true : false;
          }

          if (!this.isClient) {
            console.log('here is not client');
            this.tabIndex = 1;
            this.selectedClientSpouse.CalculatedLifeExpectancy = this.selectedClientSpouse.CalculatedLifeExpectancy;
          } else {
            this.selectedClient.clientProfile.SpouseCoverageType = this.selectedClient.clientProfile.IsSpousePrivHealthIns ? this.selectedClient.clientProfile.SpouseCoverageType : '--';
            this.tabIndex = 0;
          }

        },
        error => this.error = <any>error);
  }

  responseMMTBracket;
  // getMMTBracket() {
  //   let includePartner = this.selectedClient.clientProfile.Spouses[0] && this.selectedClient.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
  //   var currentYear = new Date().getFullYear();
  //   let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.selectedClient.clientProfile.RetirementAge, this.selectedClient.client.DOB));
  //   let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.selectedClient.clientProfile.Spouses[0].retirementAge, this.selectedClient.clientProfile.Spouses[0].dob)): null;
  //   let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
  //   console.log('bracketYear', bracketYear);
  //   this.globalService.getMMTBracket(includePartner, bracketYear)
  //     .subscribe(
  //         data => {
  //           this.responseMMTBracket = data;
  //           //console.log('MMT Brackets for Client', data);                  
  //           //If no bracket is set to the client profile, lets find the bracket for them
  //           /* if(this.incomeRangeSelectionForm.value.BracketValue == ''){
              
  //           } */
  //         },
  //         error => console.log(error));
  // }

  getMMTBracket() {
    let includePartner = this.selectedClientSpouse.maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.selectedClient.clientProfile.RetirementAge, this.selectedClient.client.DOB));
    let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.selectedClientSpouse.retirementAge, this.selectedClientSpouse.dob)): null;
    let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;

    this.selectedClient.clientProfile.HCCDYrsDiag = this.selectedClient.clientProfile.HCCDYrsDiag || 0;
    this.selectedClient.clientProfile.HCCYrsDiag = this.selectedClient.clientProfile.HCCYrsDiag || 0;
    if (this.selectedClientSpouse.maritalStatus == 'Married') {
      this.selectedClientSpouse.HCCDYrsDiag =  this.selectedClientSpouse.HCCDYrsDiag || 0;
      this.selectedClientSpouse.HCCYrsDiag = this.selectedClientSpouse.HCCYrsDiag || 0;
    }
    console.log('bracketYear', bracketYear);
    console.log('includePartner', includePartner);
    console.log('this.selectedClient', this.selectedClient)
    this.globalService.getMMTBracket(includePartner, currentYear)
            .subscribe(
                data => {

                  this.responseMMTBracket = data;
                  console.log('this.responseMMTBracket', this.responseMMTBracket)

 
 
                },
                error => console.log(error));
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  genderConvert(genderID){
    return (genderID == 1) ? 'Female' : 'Male';
  }

  getLTCStateRegions(state, isClient){
    this.globalService.getLTCStateRegions(state)
      .subscribe(
          data => {
            //console.log('metro regions', data);
            //this.responseLTCMetroRegions = data;  
            
            //we need to do a check to make this backwards compatible for already existing clients
            if(this.selectedClient.clientProfile.ClientMetroArea == '' && isClient){
              /* if(data.Rows.some(item => item.MetroRegionCode != this.selectedClient.clientProfile.ClientMetroArea)){
                //if in here, we need to set metro region to 'State Average'
                this.selectedClient.clientProfile.ClientMetroAreaName = "State Average";
              }  */
            } else {
              
              for(var i = 0; i < data.Rows.length; i++){
                if(isClient){
                  if(data.Rows[i].MetroRegionCode == this.selectedClient.clientProfile.ClientMetroArea){
                    this.selectedClient.clientProfile.ClientMetroAreaName = data.Rows[i].MetroRegion;
                  }
                } else {
                  if(data.Rows[i].MetroRegionCode == this.selectedClient.clientProfile.SpouseMetroArea){
                    this.selectedClient.clientProfile.SpouseMetroAreaName = data.Rows[i].MetroRegion;
                  }
                }
              }              
            }
          },
          error => console.log(error));
  }

  maritalStatusConvert(maritalStatus){
    //return (maritalStatus == 1) ? 'Single' : 'Married'; //Divorced | Widowed
    var spouse = JSON.parse(this.selectedClient.clientProfile.Spouses);
    if(this.selectedClient.clientProfile.IsLegalSpouse){      
      return (spouse[0] && spouse[0].maritalStatus == 'Married') ? 'Married' : 'Single';
    } else {
      //TODO: add back in when Non-Married is turned back on for Portal2, and make work with Portal1 backwards compatability
      //return (spouse[0] && spouse[0].maritalStatus == 'Married') ? 'Non-Married Partner' : 'Single';

      //NOTE: added for Portal1 backwards compatability, as Portal1 clients did not have the IsLegalSpouse bool
      return (spouse[0] && spouse[0].maritalStatus == 'Married') ? 'Married' : 'Single';
    }
  }

  displayClientBracket(bracket){
    if(bracket == 1){
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket1) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket2 - 1);
    } else if(bracket == 2){
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket2) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket3 - 1);
    } else if(bracket == 3){
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket3) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket4 - 1);
    } else if(bracket == 4){
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket4) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket5 - 1);
    } else if(bracket == 5){
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket5) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket6 - 1);
    } else { //6
      return Utils.formatToCurrency(this.responseMMTBracket.Bracket6) + ' or more';
    }
  }

  redirectClientAdditionalQuestions(){
    //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'additionalQuestions' } });
    var editRouteVariable = 'healthcare';
    if(this.router.url.includes('/clients/edit')){
      //if on client hub, use whatever you can is set for features to figure out the questionnaire
      
      //if on illustration, use that illustration questionnaire for income
      if(this.router.url.includes('/social-security')){
        editRouteVariable = 'social-security';
      } else if(this.router.url.includes('/healthcare')){
        editRouteVariable = 'healthcare';
      } else if(this.router.url.includes('/long-term-care')){
        editRouteVariable = 'long-term-care';
      } else if(this.router.url.includes('/combined')){
        editRouteVariable = 'combined';
      } else {
        //if in here then you are editing Additional Questions on the Client Hub page
        //TODO: figure out which of the questionnaires have been filled out before doing the below

        //editRouteVariable = 'healthcare';
        if(this.globalService.featHealthCare || this.globalService.featCombinedHealthcareLTC || this.globalService.featLongTermCare){
          editRouteVariable = 'healthcare';
        } else {
          //Social Security
          editRouteVariable = 'social-security';
        }
      }
    }

    //this.router.navigate(['/clients/edit/social-security'], { state: { params: 'additionalQuestions' } });
    this.router.navigate(['/clients/edit/' + editRouteVariable], { state: { params: 'additionalQuestions' } });
  }

  healthConditionConvert(clientProfile){
    var result = "";
    var count = 0;
    if(clientProfile.HCHBP > 0){
      result += "High Blood Pressure";
      count++;
    }

    if(clientProfile.HCHC > 0){
      result += ((result == "") ? "" : ", ") + "High Cholesterol";
      count++;
    }

    if(clientProfile.HCT2D > 0){
      result += ((result == "") ? "" : ", ") + "Type 2 Diabetes";
      count++;
    }

    if(clientProfile.HCT1D > 0){
      result += ((result == "") ? "" : ", ") + "Type 1 Diabetes";
      count++;
    }

    if(clientProfile.HCCD > 0){
      result += ((result == "") ? "" : ", ") + "Cardiovascular Disease";
      count++;
    }

    if(clientProfile.HCC > 0){
      result += ((result == "") ? "" : ", ") + "Cancer";
      count++;
    }

    if(clientProfile.HCT > 0){
      result += ((result == "") ? "" : ", ") + "Tobacco";
      count++;
    }

    if(clientProfile.HCMS > 0){
      result += ((result == "") ? "" : ", ") + "Multiple Sclerosis";
      count++;
    }

    if(clientProfile.HCFHDC > 0){
      result += ((result == "") ? "" : ", ") + "Family History";
      count++;
    }

    if(clientProfile.HCDCW > 0){
      result += ((result == "") ? "" : ", ") + "Mobility Dependence";
      count++;
    }

    //New conditions
    if(clientProfile.HCALZ > 0){
      result += ((result == "") ? "" : ", ") + "Alzheimer’s Disease";
      count++;
    }

    if(clientProfile.HCPARK > 0){
      result += ((result == "") ? "" : ", ") + "Parkinson’s Disease";
      count++;
    }

    if(clientProfile.HCAMP > 0){
      result += ((result == "") ? "" : ", ") + "Amputation";
      count++;
    }

    if(clientProfile.HCPTSD > 0){
      result += ((result == "") ? "" : ", ") + "PTSD";
      count++;
    }

    if(clientProfile.HCOBS > 0){
      result += ((result == "") ? "" : ", ") + "Obesity";
      count++;
    }
    
    return ((result == "") ? "No Conditions" : ((count == 1) ? result : "Multiple Conditions"));
  }

  editClient(section){
    //pass the object values and section to the edit slide over

  }

  ngOnDestroy() {

  }

  handleContactUsModal(e) {
    this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId"))});
  }

  closeModal(){
    //console.log('on clcik');
    this.modalService.close();
  }

  isEdit: boolean = false;
  isClient: boolean = true;
  section;
  //objSend = selectedClient.client
  directUserToForm(route: String) {
    this.isClient = true;
    if(route.includes('spouse-')){
      //TODO: pass everything as 'my' to edit, check change the object passed to the edit panel as necessary
      //replace string as 'spouse' to 'my'
      route = route.replace('spouse-', 'my-');

      //set if is client or not
      this.isClient = false;
    }
    
    this.section = route;
    this.isEdit = true;
    this.hideFABIcon.emit(true);
    //hide the Support icon when in Edit mode

   /*  if(this.showMobile){
      this.showMenu = false;
    }

    //this.router.navigateByUrl(`/${route}`);
    this.router.navigate([`/${route}`], { queryParams: { org: this.global.orgID } }); */
  }

  directBackToTabView(profile){
    if(profile){
      console.log('returned from Editor', profile);
      console.log('this.isClient', this.isClient);
      this.section = '';
      this.isEdit = false;
      this.hideFABIcon.emit(false);

      this.getClientData();

      //reset the client profile instead of calling the service again?
      // this.selectedClient = profile;
      // this.selectedClient.clientProfile.Premiums = JSON.parse(this.selectedClient.clientProfile.Premiums);
      // this.selectedClient.clientProfile.OOPCosts = JSON.parse(this.selectedClient.clientProfile.OOPCosts);

      // this.selectedClient.clientProfile.SpousePremiums = JSON.parse(this.selectedClient.clientProfile.SpousePremiums);
      // this.selectedClient.clientProfile.SpouseOOPCosts = JSON.parse(this.selectedClient.clientProfile.SpouseOOPCosts);

      // //this.selectedClient.clientProfile.Spouses = JSON.parse(this.selectedClient.clientProfile.Spouses);
      // var selectedClientSpouse = JSON.parse(this.selectedClient.clientProfile.Spouses);
      // this.selectedClientSpouse = selectedClientSpouse[0];
      // if (!this.isClient) {
      //   console.log('here is not client');
      //   this.tabIndex = 1;
      //   this.selectedClientSpouse.CalculatedLifeExpectancy = this.selectedClientSpouse.CalculatedLifeExpectancy;
      // } else {
      //   this.tabIndex = 0;
      // }
      
    }
  }
}
